import axios from 'axios'
const axiosclient = axios

export default axiosclient
